import React, { Component } from 'react';
import { Provider } from '../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../common/ComponentNameContext';
import Tab from '../../common/tab';
import { getQueryParams } from '../../helpers/Common';
import WatchList from './watchlist/WatchList';
import Corporate from './corporate/Corporate';
import Economy from './economy/Economy';
import './index.scss';
import ScrollComponent from './../../common/ScrollComponent';
import PreRender from './../../common/PreRender';
import currentState from './../../helpers/CurrentState';
import ConstCommon from './../../common/Const';

const mapTab = {
  economy: 1,
  watchlist: 2,
  corporate: 3,
};

class MarketCalendar extends Component {
  constructor(props) {
    super(props);
    const tabFromQuery = mapTab[getQueryParams('tab')];
    this.state = {
      currentTab:
        tabFromQuery ||
        currentState.get(
          ConstCommon.listComponent.MarketCalendar,
          'currentTab',
        ) ||
        1,
    };
  }

  changeTab = currentTab => {
    currentState.add(
      ConstCommon.listComponent.MarketCalendar,
      'currentTab',
      currentTab,
    );
    this.setState({ currentTab });
  };

  render() {
    const { id } = this.props;
    return (
      <PreRender {...this.props}>
        <Provider value={id}>
          <ComponentNameProvider
            value={ConstCommon.listComponent.MarketCalendar}
          >
            <ScrollComponent>
              <div className="top-nav px-20 d-flex flex-column h-100 market-calendar-wrapper pb-8">
                <div className="sticky pt-8">
                  <Tab
                    currentTab={this.state.currentTab}
                    listTab="marketCalendar.lstTab"
                    changeTab={this.changeTab}
                  />
                </div>
                <div className="tab-content d-flex flex-fill flex-column h-auto market-cale">
                  {this.state.currentTab === 1 && <Economy />}
                  {this.state.currentTab === 2 && <WatchList />}
                  {this.state.currentTab === 3 && <Corporate />}
                </div>
              </div>
            </ScrollComponent>
          </ComponentNameProvider>
        </Provider>
      </PreRender>
    );
  }
}

export default MarketCalendar;
